import React, { useContext, useEffect, useState } from 'react'
import './footer.css';
import { Menu, Notifications, PieChart, ShoppingCart, Widgets } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import FooterMenu from '../../components/FooterMenu';
import { AppContext } from '../../Layout/Layout';
import { Badge } from '@mui/material';
import { showToast } from '../../components/ToastUtils';
import { handleShowNotification } from '../../components/Notification/NotificationComponent';
import { CreateNotify } from '../../Layout/MutaionsAndQueries';
import { API, graphqlOperation } from 'aws-amplify';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    const [selectedIconName, setSelectedIconName] = useState(null);
    const [showSidebarMenu, setShowSidebarMenu] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isFooterVisible, setIsFooterVisible] = useState(true);
    const contextVariable = useContext(AppContext);
    const pathToIconMap = {
        "/": "Dashboard",
        "/notifications": "Notifications",
    };

    useEffect(() => {
        let prevScrollPos = window.scrollY;

        const handleScroll = () => {
            const currentScrollPos = window.scrollY;
            const isScrolledDown = prevScrollPos < currentScrollPos;

            setIsFooterVisible(!isScrolledDown);
            prevScrollPos = currentScrollPos;
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);

    const handleIconClick = (ItemName) => {

        setSelectedIconName(ItemName);
        switch (ItemName) {
            case "Dashboard":
                navigate('/');
                break;
            case "Notifications":
                navigate('/notifications');
                break;
            case "Menu":
                setShowSidebarMenu(!showSidebarMenu);
                break;
            default:
                break;
        }
    };

  
    useEffect(() => {
        setSelectedIconName(pathToIconMap[location.pathname] || "Menu");
        //eslint-disable-next-line
    }, [location.pathname]);

    // Notification subscription
    const sendMessageToNative = async (message) => {
        const NotifyObject = {
            Message: "NotificationMsg",
            data: message
        }

        // console.log("message", NotifyObject);
        if (window.ReactNativeWebView) {
            await window.ReactNativeWebView.postMessage(JSON.stringify(NotifyObject));
        } else {
            console.log("window.ReactNativeWebView is not available. Cannot send message to native app.");
        }
    }

    // Notification
    useEffect(() => {
        // getLogo();
        const filter = {
            filter: {
                CustomerId: { eq: contextVariable.userDetails["custom:contactperson_UUID"] },
                NotificationStatus: { eq: 'Unread' }
            }
        }

        const subscription = API.graphql(
            graphqlOperation(CreateNotify, filter)
        ).subscribe({
            next: ({ value }) => {
                const CreatedNotification = value.data.onCreateNotification;
                const SplitnotificationArray = JSON.parse(CreatedNotification.NotificationData);
                const updatedData = [CreatedNotification, ...contextVariable.NotificationMsg];
                // Desktop notification
                handleShowNotification(CreatedNotification);

                // Webview data transfer call
                sendMessageToNative(JSON.stringify(CreatedNotification));

                // console.log("createNofication", CreatedNotification)
                if (CreatedNotification.NotificationReasonCode === "SO_C") {
                    if (SplitnotificationArray && SplitnotificationArray[0] && SplitnotificationArray[0].PlaceOrderStatus === "Ordered") {
                        showToast(`${t(`Your order request submitted with Order ID:`)} ${SplitnotificationArray[0].SalesOrderId}`, "success")
                        contextVariable.setNotificationMsg(updatedData);
                        contextVariable.setSalesorderIdwithPlaced(SplitnotificationArray[0].SalesOrderId)
                        //   }
                    }
                }
                else if (CreatedNotification.NotificationReasonCode === "PS_S") {
                    contextVariable.setShow("PaymentSuccess");
                    contextVariable.setNotificationMsg(updatedData);
                }
                else if (CreatedNotification.NotificationReasonCode === "BPA_C") {
                    contextVariable.setShow("PaymentAdvice Updated");
                    contextVariable.setNotificationMsg(updatedData);
                }
                else if (CreatedNotification.NotificationReasonCode === "BPA_F") {
                    contextVariable.setNotificationMsg(updatedData);
                }
                else if (CreatedNotification.NotificationReasonCode === "SO_F") {

                    showToast(`${t(CreatedNotification.NotificationReasonCode)}`, "error")
                    contextVariable.setNotificationMsg(updatedData);
                    contextVariable.setUserCartIdDetails((prev) => prev.map((P) => {
                        return { ...P, CartStatus: "Open", PlaceOrderStatus: "Open" }
                    }))
                    contextVariable.setCartStatusView("ProductsInTheCart");
                    contextVariable.setCartCount(contextVariable.UserCartItems.length);
                }
                else {
                    contextVariable.setNotificationMsg(updatedData);
                }
            },
            error: (error) => {
                console.error('Subscription Error:', error);
            },
        });

        return () => {
            subscription.unsubscribe();
        };

    });


    const handleSidebarClose = () => {
        setSelectedIconName(pathToIconMap[location.pathname] || "Menu");
        setShowSidebarMenu(!showSidebarMenu);
    }


    const FooterDetails = [
        { name: "Dashboard", IconName: PieChart },
        { name: "Notifications", IconName: Notifications },
        { name: "Menu", IconName: Menu },

    ]

    return (
        <>
            <footer className={`footer-container ${isFooterVisible ? 'visible' : 'hidden'}`}>
                <div className="footer-icons flex justify-content-around">
                    {
                        FooterDetails.map((Item, index) => (
                            <div key={index} className="flex flex-column justify-content-center align-items-center"
                                onClick={() => handleIconClick(Item.name)}
                            >
                                <div className={`${selectedIconName === Item.name ? "selected" : ""}`}>
                                    <Item.IconName />
                                </div>

                                <div className={`${selectedIconName === Item.name ? "sidebar-color font-semibold" : ""} text-xs`}>
                                    {Item.name}
                                </div>
                            </div>
                        ))

                    }


                </div>
                {/* Sidebar menu */}
                {
                    showSidebarMenu &&
                    <FooterMenu
                        openSidebar={true}
                        closeSidebar={handleSidebarClose}
                    />
                }
            </footer>
        </>
    )
}

export default Footer